<template>
  <div id="app" v-if="!isWeixin || forceContinue">
    <router-view />
  </div>
  <div v-else class="weixin-tip">
    <div class="tip-card">
      <div class="tip-icon">🌐</div>
      <h2>检测到您在微信中打开</h2>
      <p class="tip-desc">部分功能在微信内置浏览器中可能无法正常使用，建议使用系统浏览器访问以获得完整体验。</p>
      <div class="tip-actions">
        <button class="btn-primary" @click="openInBrowser">
          使用系统浏览器打开
        </button>
        <button class="btn-secondary" @click="continueAnyway">
          继续在微信中访问
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { isWeixinBrowser } from '@/utils/browserDetection';

export default {
  name: 'App',
  data() {
    return {
      isWeixin: false,
      forceContinue: false,
    };
  },
  created() {
    this.checkWeixin();
  },
  methods: {
    checkWeixin() {
      this.isWeixin = isWeixinBrowser();
      if (this.isWeixin) {
        console.log('当前环境是微信浏览器');
      } else {
        console.log('当前环境不是微信浏览器');
      }
    },
    openInBrowser() {
      // 打开提示页，同时引导用户复制链接到系统浏览器
      window.location.href = './weixin-tip.html';
    },
    continueAnyway() {
      // 用户选择继续，强制渲染主页面
      this.forceContinue = true;
    },
  },
};
</script>

<style scoped>
.weixin-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f5f5f5;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
.tip-card {
  background: #fff;
  border-radius: 12px;
  padding: 40px 32px;
  max-width: 420px;
  width: 90%;
  text-align: center;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}
.tip-icon {
  font-size: 48px;
  margin-bottom: 16px;
}
.tip-card h2 {
  margin: 0 0 12px;
  font-size: 20px;
  color: #333;
}
.tip-desc {
  margin: 0 0 28px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
}
.tip-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.btn-primary {
  width: 100%;
  padding: 12px 16px;
  background: #1890ff;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: background 0.2s;
}
.btn-primary:hover {
  background: #40a9ff;
}
.btn-secondary {
  width: 100%;
  padding: 12px 16px;
  background: #fff;
  color: #666;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.2s;
}
.btn-secondary:hover {
  color: #1890ff;
  border-color: #1890ff;
}
</style>
